import { atom } from "recoil";

const deleteConfirmationPopUpAtom = atom({
  key: "deleteConfirmationPopUp",
  default: {
    isTriggered: false,
    title: "",
    isLoading: false,
    content: "",
    action: () => "",
  },
});

export default deleteConfirmationPopUpAtom;
